module.exports = __webpack_public_path__ + "static/media/206-rwanda.8a2e31ad.svg";